import { render, staticRenderFns } from "./ArchivedConversationsModal.vue?vue&type=template&id=70090a3a"
import script from "./ArchivedConversationsModal.vue?vue&type=script&lang=js"
export * from "./ArchivedConversationsModal.vue?vue&type=script&lang=js"
import style0 from "./ArchivedConversationsModal.vue?vue&type=style&index=0&id=70090a3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports